/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DictDataType
 */
export interface DictDataType {
    /**
     * 
     * @type {string}
     * @memberof DictDataType
     */
    code: string;
}

export function DictDataTypeFromJSON(json: any): DictDataType {
    return DictDataTypeFromJSONTyped(json, false);
}

export function DictDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictDataType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function DictDataTypeToJSON(value?: DictDataType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}


